module.exports = __webpack_public_path__ + "static/media/solo-preto.83fcd9f1.svg";